import { useGetPlacementsAccessLevel } from "./useGetPlacementsAccessLevel";

import { useIsHireProfessionalsEnabled } from "../PlacementCandidates/useIsHireProfessionalsEnabled";

export function useIsAnyPlacementsFeatureFlagEnabled() {
  const isHireProfessionalsEnabled = useIsHireProfessionalsEnabled();
  const { isEnabled: isPlacementsEnabled } = useGetPlacementsAccessLevel();
  return isHireProfessionalsEnabled || isPlacementsEnabled;
}
